import { CmsPageProvider } from '@gov-nx/component/web/Cms/CmsPageProvider';
import { CmsPageRender } from '@gov-nx/component/web/Cms/CmsPageRender';
import { AutorizaceView } from '@gov-nx/component/web/Page/autorizace/AutorizaceView';
import { Skeleton } from '@gov-nx/component/web/Skeleton/Skeleton';
import { PageCode } from '@gov-nx/module/page/definitions/codes';

const PageSkeleton = () => <Skeleton />;

const code = PageCode['autorizace'];
export const AutorizacePage = () => (
	<CmsPageProvider
		code={code}
		skeleton={<PageSkeleton />}>
		<CmsPageRender
			code={code}
			showFavorite={false}
			showBackButton={false}>
			<AutorizaceView code={code} />
		</CmsPageRender>
	</CmsPageProvider>
);
